import React from 'react';
import { SPACE_ASSETS_SEARCH_TYPES } from '../../utils/constants';

import isEmpty from 'lodash/isEmpty';

export const extractTextFromJSX = (type: React.ReactNode | string, index: number = 1): string => {
  if (React.isValidElement(type) && type.props?.children.length) {
    const child = type.props?.children[index];
    if (child?.props?.children === 'Suggestions') {
      return SPACE_ASSETS_SEARCH_TYPES.SUGGESTIONS;
    } else if (typeof child?.props?.children === 'string' && !isEmpty(child?.props?.children)) {
      return child?.props?.children.toLowerCase();
    }
  }

  return type as string;
};

export const pickEntryDataForSuggestion = (entry: any, isVariantPlanEnabled: boolean) => {
  if (isEmpty(entry)) return {};
  const suggestionsQuery = {};
  Object.keys(entry).forEach((field) => {
    if (field !== '$uuid' && !isEmpty(entry[field])) {
      if (entry[field]?.data_type === 'text' && !isEmpty(entry[field].value)) {
        suggestionsQuery[field] = {
          query: entry[field].value,
          weightage: field === 'title' ? 0.95 : 0.75
        };
      }
    }
  });

  if (isVariantPlanEnabled && !isEmpty(entry.variantName)) {
    suggestionsQuery['variant'] = {
      query: entry.variantName,
      weightage: 0.99
    };
  }
  return suggestionsQuery;
};

export const getLocaleCodeFromQuery = (andQuery, sendLocaleIndex = false) => {
  let localeQuery = null
  let localeIndex = -1
  andQuery.forEach((item, index) => {
    Object.keys(item).forEach((key) => {
      if (key === 'locale') {
        localeQuery = item[key]?.$in
        localeIndex = index
      }
    })
  }
  )
  if (sendLocaleIndex) {
    return {
      localeQuery,
      localeIndex
    }
  }
  return localeQuery
}